import { render, staticRenderFns } from "./PsyTestPreSessionRequest.vue?vue&type=template&id=124d3384&scoped=true&"
import script from "./PsyTestPreSessionRequest.vue?vue&type=script&lang=js&"
export * from "./PsyTestPreSessionRequest.vue?vue&type=script&lang=js&"
import style0 from "./PsyTestPreSessionRequest.vue?vue&type=style&index=0&id=124d3384&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124d3384",
  null
  
)

export default component.exports